// GENERATED by src/_console/bwaSchemaExport.js -s 4 from src/_console/skr/BWA-Schema_SKR_04.xlsx - do not edit by hand
import type { BwaSchemaRow } from "./bwaSchema";

export const BWA_SCHEMA_SKR04: readonly BwaSchemaRow[] = [
    {
        zeile: 1020,
        kennz: null,
        label: "Umsatzerlöse",
        nature: "ertrag",
        ranges: [
            [4000, 4599],
            [4690, 4799],
            [4833, 4833],
            [4860, 4864],
            [4992, 4992],
        ],
    },
    { zeile: 1040, kennz: null, label: "Bestandsveränderung FE/UE", nature: "ertrag", ranges: [[4800, 4819]] },
    { zeile: 1045, kennz: null, label: "Aktivierte Eigenleistungen", nature: "ertrag", ranges: [[4820, 4829]] },
    {
        zeile: 1051,
        kennz: "A",
        label: "Gesamtleistung",
        nature: "ertrag",
        formula: [
            { zeile: 1020, sign: 1 },
            { zeile: 1040, sign: 1 },
            { zeile: 1045, sign: 1 },
        ],
    },
    { zeile: 1060, kennz: null, label: "Material-/Wareneinkauf", nature: "aufwand", ranges: [[5000, 5999]] },
    {
        zeile: 1080,
        kennz: "B",
        label: "Rohertrag",
        nature: "ertrag",
        formula: [
            { zeile: 1051, sign: 1 },
            { zeile: 1060, sign: -1 },
        ],
    },
    {
        zeile: 1090,
        kennz: null,
        label: "Sonstige betriebliche Erlöse",
        nature: "ertrag",
        ranges: [
            [4600, 4689],
            [4830, 4832],
            [4834, 4859],
            [4865, 4959],
            [4972, 4974],
            [4990, 4991],
            [4993, 4999],
        ],
    },
    {
        zeile: 1092,
        kennz: "C",
        label: "Betrieblicher Rohertrag",
        nature: "ertrag",
        formula: [
            { zeile: 1080, sign: 1 },
            { zeile: 1090, sign: 1 },
        ],
    },
    {
        zeile: 1100,
        kennz: null,
        label: "Personalkosten",
        nature: "aufwand",
        ranges: [
            [6000, 6199],
            [6970, 6971],
            [6979, 6979],
        ],
    },
    {
        zeile: 1120,
        kennz: null,
        label: "Raumkosten",
        nature: "aufwand",
        ranges: [
            [6305, 6389],
            [6972, 6973],
        ],
    },
    { zeile: 1140, kennz: null, label: "Betriebliche Steuern", nature: "aufwand", ranges: [[7650, 7699]] },
    {
        zeile: 1150,
        kennz: null,
        label: "Versicherungen, Beiträge und Abgaben",
        nature: "aufwand",
        ranges: [[6400, 6449]],
    },
    { zeile: 1160, kennz: null, label: "Besondere Kosten", nature: "aufwand", ranges: [[6280, 6299]] },
    { zeile: 1180, kennz: null, label: "Fahrzeugkosten (ohne Steuer)", nature: "aufwand", ranges: [[6500, 6599]] },
    { zeile: 1200, kennz: null, label: "Werbe- und Reisekosten", nature: "aufwand", ranges: [[6600, 6699]] },
    { zeile: 1220, kennz: null, label: "Kosten Warenabgabe", nature: "aufwand", ranges: [[6700, 6799]] },
    {
        zeile: 1240,
        kennz: null,
        label: "Abschreibungen",
        nature: "aufwand",
        ranges: [
            [6200, 6279],
            [6976, 6977],
        ],
    },
    { zeile: 1250, kennz: null, label: "Reparaturen und Instandhaltungen", nature: "aufwand", ranges: [[6450, 6497]] },
    {
        zeile: 1260,
        kennz: null,
        label: "Sonstige Kosten",
        nature: "aufwand",
        ranges: [
            [6300, 6304],
            [6390, 6399],
            [6498, 6499],
            [6800, 6879],
            [6974, 6975],
            [6978, 6978],
        ],
    },
    {
        zeile: 1280,
        kennz: "D",
        label: "Gesamtkosten",
        nature: "aufwand",
        formula: [
            { zeile: 1100, sign: 1 },
            { zeile: 1120, sign: 1 },
            { zeile: 1140, sign: 1 },
            { zeile: 1150, sign: 1 },
            { zeile: 1160, sign: 1 },
            { zeile: 1180, sign: 1 },
            { zeile: 1200, sign: 1 },
            { zeile: 1220, sign: 1 },
            { zeile: 1240, sign: 1 },
            { zeile: 1250, sign: 1 },
            { zeile: 1260, sign: 1 },
        ],
    },
    {
        zeile: 1300,
        kennz: "E",
        label: "Betriebsergebnis",
        nature: "ertrag",
        formula: [
            { zeile: 1092, sign: 1 },
            { zeile: 1280, sign: -1 },
        ],
    },
    { zeile: 1310, kennz: null, label: "Zinsaufwendungen", nature: "aufwand", ranges: [[7300, 7366]] },
    {
        zeile: 1312,
        kennz: null,
        label: "Sonstiger neutraler Aufwand",
        nature: "aufwand",
        ranges: [
            [6880, 6969],
            [7200, 7299],
            [7367, 7399],
            [7500, 7599],
        ],
    },
    {
        zeile: 1320,
        kennz: "F",
        label: "Neutraler Aufwand",
        nature: "aufwand",
        formula: [
            { zeile: 1310, sign: 1 },
            { zeile: 1312, sign: 1 },
        ],
    },
    { zeile: 1322, kennz: null, label: "Zinserträge", nature: "ertrag", ranges: [[7100, 7145]] },
    {
        zeile: 1323,
        kennz: null,
        label: "Sonstiger neutraler Ertrag",
        nature: "ertrag",
        ranges: [
            [4960, 4971],
            [4975, 4989],
            [7000, 7099],
            [7146, 7199],
            [7400, 7499],
        ],
    },
    { zeile: 1324, kennz: null, label: "Verrechnete kalkulatorische Kosten", nature: "ertrag", ranges: [[6980, 6989]] },
    {
        zeile: 1330,
        kennz: "G",
        label: "Neutraler Ertrag",
        nature: "ertrag",
        formula: [
            { zeile: 1322, sign: 1 },
            { zeile: 1323, sign: 1 },
            { zeile: 1324, sign: 1 },
        ],
    },
    {
        zeile: 1340,
        kennz: null,
        label: "Kontenklasse unbesetzt",
        nature: "ertrag",
        ranges: [
            [6990, 6999],
            [7700, 7999],
        ],
    },
    {
        zeile: 1345,
        kennz: "H",
        label: "Ergebnis vor Steuern",
        nature: "ertrag",
        formula: [
            { zeile: 1300, sign: 1 },
            { zeile: 1320, sign: -1 },
            { zeile: 1330, sign: 1 },
            { zeile: 1340, sign: 1 },
        ],
    },
    {
        zeile: 1355,
        kennz: null,
        label: "Steuern vom Einkommen und vom Ertrag",
        nature: "aufwand",
        ranges: [[7600, 7649]],
    },
    {
        zeile: 1380,
        kennz: "I",
        label: "Vorläufiges Ergebnis",
        nature: "ertrag",
        formula: [
            { zeile: 1345, sign: 1 },
            { zeile: 1355, sign: -1 },
        ],
    },
];
